import LeftGridTemplate from "./LeftGridTemplate"; // Importing the LeftGridTemplate component
import FormPageTemplateStyles from "./FormPageTemplateStyles"; // Importing custom styles for the form page
import { Grid, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import { KeyboardBackspace } from "@mui/icons-material";
// FormPageTemplate component definition
const FormPageTemplate = ({
  rightGridForm, // JSX for the right grid form content
  leftGridTitle, // Title for the left grid section
  leftGridSubtitle, // Subtitle for the left grid section
  backUrl, // URL to navigate back to...If page does not support back navigation , just do not include backUrl in props
  textDown,
  textColor,
  leftGridBG,
}) => {
  const isSmallScreen = useMediaQuery("(max-width:800px)"); // Detects small screens
  const navigate = useNavigate();

  return (
    <FormPageTemplateStyles
      className="formPageTemplate"
      textDown={textDown}
      textColor={textColor}
      leftGridBG={leftGridBG}
      isSmallScreen={isSmallScreen}
    >
      <Grid container className="gridContainer">
        {/* Left Grid - Hidden on small screens */}
        {!isSmallScreen && (
          <Grid item xs={12} sm={6} md={4} className="leftGridWrapper">
            <LeftGridTemplate
              title={leftGridTitle}
              subtitle={leftGridSubtitle}
              backUrl={backUrl}
            />
          </Grid>
        )}
        {isSmallScreen && backUrl && (
          <IconButton
          aria-label="back"
          className="back-button"
          onClick={() => navigate(backUrl)}
        >
          <KeyboardBackspace fontSize="large" />
        </IconButton>)}


        {/* Right Grid - Full width on small screens */}
        <Grid item xs={12} sm={6} md={8} className="rightGridWrapper">
          {rightGridForm}
        </Grid>
      </Grid>
    </FormPageTemplateStyles>
  );
};

export default FormPageTemplate; // Exporting the FormPageTemplate component
